// Image preloader utility
// Importing assets ensures Vite resolves the correct URLs in dev and build
import funcard from '../assets/funcard.webp';
import laserzoneLogo from '../assets/logos/laserzone.webp';
import funzoneLogoWebp from '../assets/logos/funzone.webp';
import axezoneLogo from '../assets/logos/axezone.webp';
import exitzoneLogo from '../assets/logos/exitzone.webp';
import golfzoneLogo from '../assets/logos/golfzone.webp';
import bashzoneLogo from '../assets/logos/bashzone.webp';
import paintzoneLogo from '../assets/logos/paintzone.webp';
import pixelzoneLogo from '../assets/logos/pixelzone.webp';
import rallyezoneLogo from '../assets/logos/rallyezone.webp';
import funzoneWordmarkLightmode from '../assets/logos/funzone_wordmark_lightmode.webp';
import funzoneWordmarkDarkmode from '../assets/logos/funzone_wordmark_darkmode.webp';

// Cache for preloaded images
const imageCache = new Map();

/**
 * Preloads a single image
 * @param {string} src - Image source path
 * @returns {Promise} - Promise that resolves when image is loaded
 */
const preloadImage = src => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      imageCache.set(src, img);
      resolve(img);
    };
    img.onerror = reject;
    img.src = src;
  });
};

/**
 * Preloads critical images for the application
 * This function should be called early in the app lifecycle
 */
export const preloadCriticalImages = async () => {
  try {
    await Promise.all([
      preloadImage(funcard),
      preloadImage(laserzoneLogo),
      preloadImage(funzoneLogoWebp),
      preloadImage(funzoneWordmarkLightmode),
      preloadImage(funzoneWordmarkDarkmode),
      preloadImage(axezoneLogo),
      preloadImage(exitzoneLogo),
      preloadImage(golfzoneLogo),
      preloadImage(bashzoneLogo),
      preloadImage(paintzoneLogo),
      preloadImage(pixelzoneLogo),
      preloadImage(rallyezoneLogo),
    ]);
  } catch (error) {
    console.warn('Failed to preload some critical images:', error);
  }
};

/**
 * Gets a preloaded image from cache
 * @param {string} src - Image source path
 * @returns {HTMLImageElement|null} - Preloaded image or null if not found
 */
export const getPreloadedImage = src => {
  return imageCache.get(src) || null;
};
